import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as yup from "yup";
import { http } from "../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";

const requestSchema = yup.object({
  productId: yup.number().required(),
});

export function useUnbindShopifyProductMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.post(HTTP_ENDPOINTS.shopifyProductList.unbind(), {
        product_id: req.productId,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.shopifyProductList.get],
        });
        options.onSuccess?.(...args);
      },
    },
  );
}
